<template>
<div class="inksel">
	<Inkfilter/>
	<Inks/>
</div>
</template>

<script>
import Inkfilter from './Inkfilter.vue';
import Inks from './Inks.vue';

export default {
	name: 'Inkselector',
	components: { Inks, Inkfilter },
}
</script>

<style scoped>

div.inksel {
	display: flex;
        flex-flow: row;
	margin-left: auto;
	margin-right: auto;
	max-width: 1200px;
}

</style>



// WEBPACK FOOTER //
// src/components/Inkselector.vue